export default __webpack_public_path__ + "static/media/IMG_1386.f96f0c24.jpg";